import dayjs from "dayjs";
import "dayjs/locale/de";

dayjs.locale("de"); // todo

export default function (value, format = "") {
  if (value == null) {
    return "";
  }

  if (format === "long") {
    return dayjs(value).format("DD.MM.YYYY HH:mm");
  }

  if (format === "short") {
    return dayjs(value).format("DD.MM.YY");
  }

  if (format === "hhmm") {
    return dayjs(value).format("HH:mm");
  }

  if (format === "LL") {
    return dayjs(value).format("LL");
  }

  if (format === "dddd") {
    return dayjs(value).format("dddd");
  }

  return dayjs(value).format("DD.MM.YYYY");
}
